<template>
  <div class="newwarp">
    <div class="Opencontent">
      <div style="display:flex; margin-top: 20px;">
        <el-input v-model="input" placeholder="请输入内容" style="width:200px;margin-left:20px"></el-input>
        <el-button
          type="primary"
          icon="el-icon-arrow-left"
          class="btn"
          style="margin-left:20px"
          size="small"
          @click="backpage"
        >返回</el-button>
      </div>
      <div class="midtable">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          el-table-column
          :header-cell-style="tableHeaderColor"
          height="300px"
          @current-change="tablecheck"
        >
          <el-table-column prop="isPointed" label="执行方案" align="center" width="100px">
            <template slot-scope="scope">
              <el-button
                @click="openClick(scope.row)"
                type="text"
                size="small"
              >{{scope.row.isPointed ==0?"未启用":"启用"}}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="方案名称" align="center"></el-table-column>
          <el-table-column prop="displayName" label="方案描述" align="center"></el-table-column>
          <el-table-column prop="updateTime" label="更新时间" align="center"></el-table-column>
          <el-table-column prop="ction" label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                icon="el-icon-delete-solid"
                @click="handleClick(scope.row)"
                type="text"
                size="small"
              >删除方案</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="bottomtable">
        <el-table
          :header-cell-style="tableHeaderColor"
          :data="tableDatatwo"
          border
          style="width: 100%"
          height="400px"
        >
          <el-table-column prop="measureName" label="检测点名称" width="180" align="center"></el-table-column>
          <el-table-column prop="demandType" label="调整方式" align="center">
            <template slot-scope="scope">
              <div class="slidertable">
                <el-slider
                  @change="changeSlider(scope.row)"
                  v-model="scope.row.demandType"
                  :show-tooltip="false"
                  :step="1"
                  show-stops
                  :min="-12"
                  :max="12"
                  :marks="marks"
                  style="margin-bottom:20px"
                  disabled
                ></el-slider>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    checknode: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      input: "",
      marks: {
        "-12": "12",
        "-11": "11",
        "-10": "10",
        "-9": "9",
        "-8": "8",
        "-7": "7",
        "-6": "6",
        "-5": "5",
        "-4": "4",
        "-3": "3",
        "-2": "2",
        "-1": "1",
        "0": "0",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
        "10": "10",
        "11": "11",
        "12": "12"
      },
      tableData: [],
      tableDatatwo: [],
      staiceTableData: []
    };
  },
  watch: {
    input(newVal, oldVal) {
      let vm = this;
      let arr = [];
      console.log(newVal);
      console.log(vm.staiceTableData);
      vm.staiceTableData.map(item => {
        // console.log(item);
        if (item.name.toString().indexOf(newVal) >= 0) {
          arr.push(item);
        }
        // if (item.displayName.toString().indexOf(newVal) >= 0) {
        //   arr.push(item);
        // }
      });
      console.log(arr);
      if (newVal == "") {
        vm.tableData = vm.staiceTableData;
      } else {
        vm.tableData = arr;
      }
    }
  },
  mounted() {
    console.log(this.checknode);
    this.getData();
  },
  methods: {
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      //改表头颜色
      if (rowIndex === 0) {
        return "background-color: #F3F3F3;color: #666;font-size:14px";
      }
    },
    getData() {
      this.$api.nhtj.getDemandScheme(0).then(res => {
        console.log(res);
        this.tableData = res.data;
        this.staiceTableData = JSON.parse(JSON.stringify(res.data));
      });
    },
    tablecheck(e) {
      console.log(e);
      this.tableDatatwo = e.detail;
    },
    changeSlider() {},
    backpage() {
      console.log(this.checknode);
      this.$emit("backpage", true, this.checknode);
    },
    handleClick(e) {
      console.log(e);
      this.$api.nhtj.deleteDemandScheme(e.id).then(res => {
        console.log(res);
        this.$message({
          message: "删除成功！",
          type: "success"
        });
        this.getData();
      });
    },
    openClick(e) {
      console.log(e);
      if (e.isPointed == 0) {
        this.$api.nhtj.setPointedScheme(e.id, 1).then(res => {
          this.$message({
            message: "启用成功！",
            type: "success"
          });
          this.getData();
        });
      } else {
        this.$api.nhtj.setPointedScheme(e.id, 0).then(res => {
          this.$message({
            message: "禁用成功！",
            type: "success"
          });
          this.getData();
        });
      }
    },
    clickchange(e) {
      console.log(e);
    },
    formatter(row, column, cellValue, index) {
      console.log(row);
    }
  }
};
</script>

<style lang="scss" scoped>
.newwarp {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  display: flex;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
  justify-content: center;
}
.Opencontent {
  background: #fff;
  // display: flex;
  // flex-flow: column;
  width: 70%;
  padding: 0 10px;
  padding-bottom: 10px;
}
.midtable {
  margin-top: 20px;
}
.bottomtable {
  margin-top: 20px;
}
::v-deep.slidertable {
  .el-slider__marks {
    .el-slider__marks-text:first-child {
      left: 1% !important;
    }
    .el-slider__marks-text:last-child {
      left: 98.2% !important;
    }
  }
  .el-slider__bar {
    background-color: initial !important;
  }
}
</style>